import { CalendarMode } from "PFApp/booking/types";
import PageTabs from "PFComponents/page/page_tabs";
import BookingProjectsIcon from "PFIcons/booking_projects.svg";
import BookingWorkforceIcon from "PFIcons/booking_workforce.svg";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "./view_tabs.module.scss";

type Tab = {
  id: CalendarMode;
  displayElement: JSX.Element;
};

export const ViewTabs = (): JSX.Element => {
  const { t } = useTranslation("bookingModule");

  const { calendarMode, setCalendarMode, splitMode } = useBookingsOverviewContext();

  const tabs: Tab[] = useMemo(
    () => [
      {
        id: CalendarMode.Projects,
        displayElement: (
          <span className={css.tab}>
            <BookingProjectsIcon />
            {t("projects.title")}
          </span>
        ),
        disabled: splitMode
      },
      {
        id: CalendarMode.Workforce,
        displayElement: (
          <span className={css.tab}>
            <BookingWorkforceIcon />
            {t("workforce.title")}
          </span>
        ),
        disabled: splitMode
      }
    ],
    [splitMode, t]
  );

  const handlePageTabChange = (value: Tab) => {
    setCalendarMode(value.id);
  };

  return (
    <PageTabs
      rootClassName={css.modeTabs}
      items={tabs}
      active={calendarMode}
      handleClick={handlePageTabChange}
    />
  );
};
